<script>
import CheckoutForm from "../CheckoutForm.vue";
import StandardLeft from "./StandardLeft.vue";
import Footer from "../../Footer.vue";
import SignUpTrial from "@/views/SignUpTrial.vue";
import GiftTextDescription from "@/components/GiftTextDescription.vue";
// import TrialQuestionnaireForm from "@/components/TrialQuestionnaireForm.vue";

export default {
  name: "StandardCheckout",
  props: ['routeName', 'combos', 'discount', 'variant'],
  page: {
    title: "Checkout",
    meta: [{ name: "description", content: "The Checkout page." }]
  },
  components: {
    StandardLeft,
    CheckoutForm,
    GiftTextDescription,
    SignUpTrial,
    // TrialQuestionnaireForm,
    Footer,
  },
  data: function() {
    return {
      guaranteeImg: "ssl-30days.jpg",
    }
  },
  computed: {
    expirationDate: function() {
      if (this.variant && this.variant === 'B') {
        return new Date('10 January 2023 23:59:59 UTC')
      }
      else if (this.$route.name === 'PrivateOffer') {
        return new Date('30 July 2023 23:59:59 PST')
      }
      else if (this.$route.name === 'bonusclass') {
        return new Date('15 August 2023 23:59:59 PST')
      }
      return null;
      // return this.variant && this.variant === 'B' ? new Date('10 January 2023 23:59:59 UTC') : null;
    },
  },
};
</script>

<template>
  <b-container>
    <b-row v-if="this.routeName != 'TwoDayOffer' && this.routeName != 'BonusClass'">
      <b-col sm="12" class="logo-row header-checkout">
        <div>
          <img src="@/assets/images/dropsmart-logo.png" alt="Logo" class="logoCheckout" />
        </div>
        <div class="call-to-action">
          <h2>THE MOST TRUSTED ESSENTIAL OIL RESOURCE CENTER</h2>
        </div>
      </b-col>
    </b-row>

    <!-- BANNER TO TWO DAY OFFER -->
    <b-row v-if="this.routeName == 'TwoDayOffer'" class="banner-container">
      <b-col sm="12" class="logo-row" v-if="this.routeName == 'TwoDayOffer'">
        <div>
          <img src="@/assets/images/banner-two-day-offer.png" alt="Banner" class="banner" />
        </div>
        <div class="call-to-action">
        </div>
      </b-col>
    </b-row>

    <!-- BANNER TO 30% OFF -->
    <b-row v-if="this.routeName == '30'" class="banner-container">
      <b-col sm="12" class="logo-row" v-if="this.routeName == '30'">
        <div>
          <img src="@/assets/images/banner-30-off.png" alt="Banner" class="banner" />
        </div>
        <div class="call-to-action">
        </div>
      </b-col>
    </b-row>

    <!-- BANNER TO BONUS CLASS -->
    <b-row v-if="this.routeName == 'BonusClass'" class="banner-container">
      <b-col sm="12" class="logo-row" v-if="this.routeName == 'BonusClass'">
        <div>
          <img src="@/assets/images/banner-bonus-class-offer-50-off-next-level.png" alt="Next Level Bonus Class" class="banner" />
        </div>
        <div class="call-to-action">
        </div>
      </b-col>
    </b-row>

    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left">
        <StandardLeft v-if="this.routeName != 'GiftCard'"/>

        <!-- LEFT COLUMN CONTENT IN CASE IS XTMAS GIFT -->
        <GiftTextDescription v-if="this.routeName == 'GiftCard'"/>
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <CheckoutForm :loadCombos="combos" 
                      :guaranteeImg="guaranteeImg" 
                      :expirationDate="expirationDate"
                      :discount="discount" 
                      :changeBus="this" 
                      :variant="variant"
                      v-if="this.routeName != 'GiftCard'"/>
        
        <!-- RIGHT COLUMN CONTENT IN CASE IS XTMAS GIFT -->
        <SignUpTrial :routeName="routeName" v-if="this.routeName == 'GiftCard'"/>
        <StandardLeft :routeName="routeName" v-if="false"/>
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 300;
    color: #999999 !important;
  }
}
.sub-header-checkout {
  text-align: center;
  h2 {
    font-size: 20px !important;
    font-weight: 400;
    color: #000333 !important;
  }
}

@media screen and (min-width: 481px) {
  .header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }

}

.textGDPR {
  color: $color;
  font-size: 16px;
  margin: 30px 0;
  text-align: center;
}

.support {
  color: #666666;
  font-size: 16px;
  b {
    &:hover {
      color: #666666;
    }
  }
  a {
    color: #666666;
    &:hover {
      color: $link-color;
    }
  }
  &:hover {
    color: #666666;
  }
}

.logo-row {
  margin: 65px 0 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
  .banner {
    width: 100%;
  }
}
.call-to-action {
  margin: 50px 0 0px;
}
.call-to-action h2 {
  font-family: "OpenSans";
  font-size: 36px;
  color: #999999;
  text-transform: uppercase;
  line-height: 1.3;
}

ul.benefits li {
  list-style: none;
  line-height: 56px;
  font-size: 20px;
}

ul.benefits li {
  list-style: none;
  line-height: 56px;
  font-size: 20px;
}

ul.benefits li svg {
  font-size: 33px;
  margin-right: 5px;
  vertical-align: middle;
}

ul.benefits li:nth-child(1) svg {
  color: #5f1e5e;
}

ul.benefits li:nth-child(2) svg {
  color: #8c329c;
}

ul.benefits li:nth-child(3) svg {
  color: #df38c2;
}

ul.benefits li:nth-child(4) svg {
  color: #de2b7f;
}

ul.benefits li:nth-child(5) svg {
  color: #d81a1a;
}

ul.benefits li:nth-child(6) svg {
  color: #f07421;
}

ul.benefits li:nth-child(7) svg {
  color: #fcb51c;
}

ul.benefits li:nth-child(8) svg {
  color: #f4ea25;
}

ul.benefits li:nth-child(9) svg {
  color: #c9ff39;
}

ul.benefits li:nth-child(10) svg {
  color: #84e75c;
}

ul.benefits li:nth-child(11) svg {
  color: #22d949;
}

.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: maroon;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: var(--accent-color);
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: var(--accent-color);
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.card-label {
  width: 8ch;
  text-align: right;
  font-family: "OpenSans";
}

@media screen and (max-width: 359px) {
  form {
    .radio-products {
      padding: 0;
    }
  }
}

@media screen and (max-width: 767px) {
  form {
    font-size: 16px;
    .input-group {
      input {
        font-size: 16px;
      }
      .custom-control-inline {
        margin: 0;
      }
    }
  }
  .button-checkout {
    font-size: 18px;
  }
  .checkout-checkbox {
    padding: 0;
  }
  .boxCheckout {
    border: 0;
    padding: 0;
  }
  .call-to-action h2 {
    font-size: 22px;
  }
  ul.benefits {
    margin: 0 !important;
    padding: 40px 0 0 0;
  }
  ul.benefits li {
    margin: 0;
    font-size: 15px;
    line-height: 40px;
  }
  ul.benefits li svg {
    font-size: 23px;
  }
  .testimonials {
    padding: 20px 25px;
    p {
      font-size: 16px;
      line-height: 25px;
    }
  }
  .textMoneyback {
    font-size: 20px;
    color: #000000;
  }
  .text-riskFree {
    font-size: 13px;
  }
  .footer {
    padding: 60px 0 40px;
    a {
      font-size: 13px;
      margin: 0 15px;
    }
  }
}

.signup-trial-container {
  justify-content: right;
}

@media screen and (max-width: 991px) {
  .hideDesktop {
    margin: 20px -15px;
    max-width: 360px;
    width: calc(100% + 30px);
  }
  .text-riskFree {
    margin-bottom: 0;
  }
  .signup-trial-container {
  justify-content: center;
}
}

@media screen and (min-width: 992px) {
  ul.benefits {
    margin-top: 600px;
  }
  .hideDesktop {
    display: none;
  }
}

@media screen and (max-width: 1365px) {
  form {
    .card {
      .order-total {
        .vat-text:hover {
          .vat-details {
            right: -10px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.call-to-action h2 {
  margin: 50px 0 70px;
}
</style>
